import { GenderType } from '@/types/bff/gql-schema';

const convertGender = (gender?: GenderType) => {
  switch (gender) {
    case GenderType.Female:
      return 'female';
    case GenderType.Male:
      return 'male';
    default:
      return 'none';
  }
};

export { convertGender };
